module.exports = __webpack_public_path__ + "img/48.2e75abb3.jpg";